import {
    MobileOtpResponse,
} from "../../@types/DRO/MobileOtpResponse"
import axios, { AxiosInstance, AxiosResponse } from "axios"

export class MobileOtpRequestApi {
    public static api = new MobileOtpRequestApi()
    private instance: AxiosInstance

    constructor() {
        this.instance = axios.create({
            baseURL: "https://stag-micro.bcykal.com/mobycy/auth",
            headers: {
                "Content-Type": "application/json",
            },
        })
    }

    getToken() {
        return localStorage.getItem("token")
    }

    async MobileOtpRequest(
        encryptedPhoneNumber: string
    ): Promise<MobileOtpResponse> {
        const token = this.getToken()

        const response: AxiosResponse<MobileOtpResponse> =
            await this.instance.post(
                "/generate/otp",
                { encryptedPhoneNumber },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            )

        return response.data
    }

    async verifyOtp(
        encryptedPhoneNumber: string,
        otp: string,
        email?: string
    ): Promise<MobileOtpResponse> {
        const response: AxiosResponse<MobileOtpResponse> =
            await this.instance.post("/verify/otp", {
                encryptedPhoneNumber,
                otp,
            })

        return response.data
    }
}
